import { Site, SiteManager } from "@kosmod/graphics-2d";
import { s } from "@kosmod/pancake";

export const kosmodSite = Site.def({
  // landing
  home: { path: '/' },
  features: { path: '/features' },
  development: { path: '/development' },
  market: { path: '/market' },
  plus: { path: '/plus' },

  // legal
  termsOfUse: { path: '/policy/terms-of-use' },
  privacyPolicy: { path: '/policy/privacy' },

  // account
  profile: { path: '/profile' },
  login: { path: '/login' },
  signUp: { path: '/sign-up' },
  signOut: { path: '/sign-out' },

  // games
  invitation: { path: '/invitation', query: s.o({ id: s.str, code: s.str }) },
  games: { path: '/games', query: s.o({ game: s.optional(s.str) }) },
  library: { path: '/library', query: s.o({ game: s.optional(s.str) }) },

  // rooms
  demo: { path: '/demo' },
  room: { path: '/room', query: s.o({ room: s.str, game: s.str, invite: s.optional(s.str) }) },
})

export type KosmodPageState = Site.PageState<typeof kosmodSite>;
export type KosmodPage = Site.Page<typeof kosmodSite>;

export type KosmodSite = SiteManager<typeof kosmodSite>;
